import Category from "../components/Category";
import SairahExperience from "../components/SairahExperience";
import Hero from "../components/Hero";
import { ScrollToTop } from "../components/ScrollToTop";
import Collections from "../components/Collections";
import CollectionsNew from "../components/CollectionsNew";
import OccasionalStyle2 from "../components/Occasional Section/OccasionalStyle2";
import HomeBanner from "../components/HomeBanner";
import { ProductSlider } from '../components/ProductSlider';
import ShopByGender from '../components/ShopByGender';
import ShopByPrice from '../components/ShopByPrice';
import InfluencerSection from '../components/InfluencerSection';
import Mobikwik from '../components/Mobikwik';
//7506699870
//7045449892 w
//ajay.g@sairahjewles.com
export default function Home() {

  return (
    <div className="bg-white">

      <Hero cat={"main"} />

      <Category />

      <ProductSlider
        title="FOR HIM"
        queryUrl={`gender=male&sortBy=latest&order=desc&limit=25`}
        // bannerCategory="homeMen"
      />

      <InfluencerSection />

      <ShopByPrice />

      <ProductSlider
        title="DIVINE COLLECTION"
        queryUrl={`productCollections=66f7d8333bd3aed2eb699992&limit=25`}
        bannerCategory="homeDivine"
      />

      <Mobikwik />

      <SairahExperience />


      <ProductSlider
        title="URBAN CHIC"
        queryUrl={`productCollections=68039aef49ff5b43ba2ea0f6&limit=25`}
        bannerCategory="urbanChic"
      // isTopPad="true"
      />

      <ShopByGender />

      <ProductSlider
        title="LATEST ARRIVAL"
        // title="FRESH ARRIVALS"
        queryUrl={`sortBy=latest&order=desc&limit=25`}
        bannerCategory="newArrivals"
      // isBgColor="true"
      />

      <HomeBanner category={"occasional"} />
      <OccasionalStyle2 />

      <ProductSlider
        title="PET COLLECTION"
        queryUrl={`productCollections=66f7d8233bd3aed2eb69988c&limit=25`}
        bannerCategory="petCollection"
      />

      <HomeBanner category={"collections"} />
      <CollectionsNew />

      <ProductSlider
        title="JEWELLERY SETS"
        queryUrl={`categories=675c21bd88711ca285cd88bf&limit=25`}
        bannerCategory="homeJewellerySet"
      // labelText="SETS"
      // isBgColor="true"
      />

      {/* <ProductSlider
        title="COLLECTIONS"
        queryUrl={`productCollections=66f7d8233bd3aed2eb69988c`}
        bannerCategory="collections"
      /> */}

      <HomeBanner category={"latestColl"} />
      <Collections />

    </div>
  );
}
